export default __webpack_public_path__ + "static/ipad-l-4a9fa2c6ba22960b5b06264415a60f33.jpg";